module.exports = __webpack_public_path__ + "static/media/transit-number.f63bd62c.png";